export class CancelPackageReasonMiniEntity {
  id?: number
  title?: string | null
}

